import {
  ConfirmarMedicoSolicitanteContainer,
  MatriculaContainer,
} from "./localStyle";

import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import CardSelect from "_+_Portal/_-_Autocheckin/components/genericos/CardSelect/CardSelect";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { useContext, useState } from "react";
import { GlobalContext } from "global/context/Provider";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { wsPutSeleccionaMedicoTurnoQr } from "_+_Portal/_-_Autocheckin/context/action/medicoPorMatricula";
import { PortalContext } from "_+_Portal/context/Provider";
import { proximoPaso } from "../PagesFun";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { showToaster } from "global/context/action/toaster/toaster";

const ConfirmarMedicoSolicitante = ({ turnoActual }) => {
  // -------------------- UseStates --------------------
  const [loading, setLoading] = useState({ loading: false, id: 0 });
  // -------------------- UseStates --------------------

  // -------------------- Contexto --------------------
  const { selectDropDownState } = useContext(PortalContext);
  const {
    turnosSeleccionadosState,
    medicoPorMatriculaState,
    pasoDispatch,
    medicoPorMatriculaDispatch,
    rutaState,
    rutaDispatch,
    pasoState,
  } = useContext(AutocheckContext);
  const { toasterDispatch } = useContext(GlobalContext);
  // -------------------- Contexto --------------------

  // -------------------- Constantes --------------------

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados.data;

  const turno = listTurnosSeleccionado[turnoActual];

  const medico = turno.medico;
  const especialidad = turno.especialidad;

  const medicosArray = medicoPorMatriculaState?.medicoPorMatricula?.data;
  const idPacFamiliar = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.codigo
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.codigo
    : false;

  // -------------------- Constantes --------------------

  // -------------------- Funciones --------------------

  const nextStepPutSeleccionarMedicoTurno = (isCorrect) => {
    if (isCorrect) {
      const ruta = rutaState.ruta.data;
      setRuta(proximoPaso(ruta, setPaso, pasoDispatch))(rutaDispatch);
    } else {
      showToaster(
        {
          texto: "La matricula ingresada no es valida",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    setLoading({ loading: false, id: 0 });
  };

  const handleClickVolver = () => {
    // let informacion = {
    //   ...validaTurnoState.informacionTurno.data,
    //   actual: validaTurnoState.informacionTurno.data.actual - 1,
    // };
    // setInformacionValidaTurno(informacion)(validaTurnoDispatch);
    if (pasoState.circuito === "labo") {
      setPaso("ResumenLabo")(pasoDispatch);
    } else {
      setPaso("Resumen")(pasoDispatch);
    }
  };

  const seleccionarMedico = (element) => {
    setLoading({ id: element.codigo, loading: true });

    if (turno.idProtocolo > 0) {
      // wsPutSeleccionarMedicoLabo(
      //   turno.idProtocolo,
      //   element.codigo,
      //   idPacFamiliar,
      //   setPaso,
      //   nextStep
      // )(validaTurnoDispatch);
    } else {
      wsPutSeleccionaMedicoTurnoQr(
        turno.idturno,
        element.codigo,
        nextStepPutSeleccionarMedicoTurno
      )(medicoPorMatriculaDispatch);
    }
  };
  // -------------------- Funciones --------------------

  return (
    <LayoutPasos
      volverTo="/autocheckin/resumen"
      handleClick={handleClickVolver}
      type={"no-circle"}
      title={"medico solicitante"}
    >
      <ConfirmarMedicoSolicitanteContainer>
        <CardBlueHeart
          medico={medico ? medico : especialidad}
          turnoTitle={especialidad}
          pasoActual={turnoActual + 1}
          pasoTotal={listTurnosSeleccionado.length}
        />
        <MatriculaContainer
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
        >
          <h1>
            Seleccioná la matrícula del{" "}
            <span className={"bold"}>profesional</span> que corresponde a tu
            orden.
          </h1>
          {medicosArray.map((element, index) => {
            return (
              <CardSelect
                nombreDoc={element.nombre}
                matNac={element.matriculaNacional}
                matProv={element.matriculaProvincial}
                onclick={() => {
                  seleccionarMedico(element);
                }}
                key={index}
                loading={
                  element.codigo === loading.id ? loading.loading : false
                }
              />
            );
          })}
        </MatriculaContainer>
      </ConfirmarMedicoSolicitanteContainer>
    </LayoutPasos>
  );
};

export default ConfirmarMedicoSolicitante;
